import { addStyles } from 'ethcss'
import { colors, IStyles, mediaCSS } from 'theme'
import grid from 'blocks.simple/grid/grid.jcss'

export const statusStyles: IStyles = {
    status: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 12,
        width: 40,
        height: 28,
        border: '4px solid transparent',
        borderRadius: '7px',
        margin: '0 0.4em',
        boxShadow: '0px 0px 1px 1px rgba(255, 255, 255, 0.5)',
    },
    statusList: {
        width: '26% !important',
    },
    disable: {
        opacity: 0.4,
    },
    main: {
        ...grid.flex,
        ...grid.normalCenter,
        ...grid.center,
        width: '100%',
    },
    statusText: {
        display: 'block',
        verticalAlign: 'middle',
    },
    marker: {
        marginRight: 5,
        verticalAlign: 'middle',
    },
}

addStyles(statusStyles)
